import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1280px;
	margin: 0 auto;

	padding: 50px 20px;
	color: ${CSSVars.black};

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}

	h2 {
		text-align: center;
		margin: 0 auto;
		font-size: ${CSSVars.fontSize2XL};
		max-width: 780px;
	}

	h3 {
		text-align: center;
		font-size: ${CSSVars.fontSizeMD};
		margin: 20px auto 0;
		max-width: 350px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			max-width: unset;
			font-size: ${CSSVars.fontSizeLG};
		}
	}

	.ideal-candidate-container {
		margin-top: 100px;
		text-align: left;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			text-align: center;
			margin-top: 200px;
		}

		p {
			margin: 20px auto 0;
			max-width: 930px;
		}
	}

	.steps {
		display: flex;
		flex-wrap: wrap;
		gap: 50px;
		margin-top: 80px;
		
		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			gap: 50px;
		}
		
		.step {
			flex: 300px;
			border: 1px solid ${CSSVars.gray50};
			padding: 50px 20px 20px;
			border-radius: 8px;
			position: relative;

			svg {
				top: -32px;
				position: absolute;
			}

			h4 {
				font-size: ${CSSVars.fontSizeLG};
				margin-bottom: 10px;
				font-weight: 500;
			}

			p {
				font-weight: 300;
				font-size: ${CSSVars.fontSizeMD};
				opacity: 0.8;
			}
		}
	}
`;
